import BackIcon from "@assets/images/chevron-left.svg";
import CloseModal from "@assets/images/CloseModal.svg";
import SearchIcon from "@assets/images/search-dark.svg";
import ShippingIcon from "@assets/images/shipping-icon.svg";
import { Button, Dialog, DialogActions, DialogTitle } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { useSearchSuggestionShipTosforCipLazyQuery } from "@saleor/graphql";
import { makeStyles } from "@saleor/macaw-ui";
import { mapEdgesToItems } from "@saleor/utils/maps";
import { FormikProps } from "formik";
import React, { useState } from "react";
import InlineSVG from "react-inlinesvg";
import { FormattedMessage } from "react-intl/lib";

import SoldToForShipToInputSuggestion from "../SoldToInputSuggestion/SoldToForShipTo";
export interface ModalSearchShipTo {
  onClose?: () => void;
  open?: boolean;
  formik?: FormikProps<any>;
  handleSubmit?: (value) => void;
  initialValue?: string;
  onBack?: () => void;
  isChangeFlow?: boolean;
  currentAction?: string;
}
export const useStyles = makeStyles(
  theme => ({
    dialogTitle: {
      textAlign: "left",
      padding: "0",
      display: "flex"
    },
    dialogTitleWrap: {
      height: "40px",
      display: " flex",
      alignItems: "center",
      lineHeight: "normal",
      marginBottom: "24px",
      marginTop: "0px"
    },
    mainTitle: {
      fontSize: "2rem",
      color: theme.palette.grey[900],
      fontWeight: 700
    },
    subTitle: {
      color: theme.palette.info.main,
      fontWeight: 400,
      fontSize: "1.6rem"
    },
    closeDialog: {
      cursor: "pointer"
    },
    root: {
      "& .MuiPaper-root": {
        maxWidth: 600,
        width: "100%",
        borderRadius: 12,
        padding: " 24px 32px"
      },
      "& .MuiDialogTitle-root": {
        padding: "0",
        display: "flex"
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        paddingBottom: 24
      },
      "& .MuiFormControlLabel-label": {
        fontSize: "1.4rem",
        lineHeight: "22px",
        color: theme.palette.grey[900]
      },
      "& .MuiRadio-root svg": {
        width: 18,
        height: 18
      }
    },
    detailTitle: {
      fontWeight: "bold",
      marginBottom: 10,
      "& .normalText": {
        fontWeight: "normal"
      }
    },
    dialogContent: {
      maxHeight: "calc(100% - 64px)",
      overflow: "auto",
      padding: "0 !important",
      "&::-webkit-scrollbar": {
        height: "14px",
        background: "#FFFFFF"
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 10,
        border: "4px solid #FFFFFF",
        height: "6px"
      }
    },
    labelRadio: {
      marginBottom: "2rem"
    },
    rowlength: {
      color: "#009FB8",
      fontFamily: "SCG",
      fontSize: "20px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "26px"
    },
    formControlLabel: {
      marginBottom: "2.5rem"
    },
    buttonAction: {
      width: "50%",
      height: 48
    },
    nameHead: {
      marginTop: 0,
      marginLeft: "12px",
      display: "flex !important",
      h2: {
        display: "flex !important"
      }
    },
    buttonWrap: {
      padding: "0px",
      marginTop: "24px"
    },
    bodyBorder: {
      background: "#CCCCCC",
      padding: "20px",
      borderRadius: "4px"
    }
  }),
  { name: "ModalAddress" }
);

const ModalSearchShipTo: React.FC<ModalSearchShipTo> = props => {
  const {
    open,
    onClose,
    formik,
    handleSubmit,
    initialValue,
    onBack,
    isChangeFlow,
    currentAction
  } = props;

  const [shipToParty, setShipToParty] = useState<string>("");
  const [isInValidForm, setIsInValidForm] = useState<boolean>(false);
  const classes = useStyles();

  const [
    getDataSuggestionsDemostic,
    {
      data: fetchDataSuggestionsDemostic,
      loading: loadingDataSuggestionDemostic
    }
  ] = useSearchSuggestionShipTosforCipLazyQuery({
    fetchPolicy: "no-cache"
  });
  const dataOptions = (
    mapEdgesToItems(fetchDataSuggestionsDemostic?.searchSuggestionShipTo) || []
  ).map(data => ({
    title: `${data.displayCodeName} ${data.addressText}`,
    value: data.partnerCode
  }));
  const handleSelectedSearch = e => {
    if (e.value) {
      setShipToParty(e.title);
      setIsInValidForm(false);
    } else {
      setShipToParty("");
    }
  };
  const onSubmit = () => {
    if (shipToParty !== "") {
      handleSubmit(shipToParty);
      setIsInValidForm(false);
      onClose();
    } else {
      setIsInValidForm(true);
    }
  };
  return (
    <Dialog open={open} className={classes.root}>
      <DialogTitle className={classes.dialogTitle}>
        <h2 className={classes.dialogTitleWrap}>
          <img src={ShippingIcon} alt="" />
          <MyTypography variant={"h6"} className={classes.nameHead}>
            Ship-To Party
          </MyTypography>

          <InlineSVG
            onClick={onClose}
            src={CloseModal}
            style={{
              marginLeft: "336px",
              height: "23px",
              width: "24px",
              cursor: "pointer"
            }}
          />
        </h2>
      </DialogTitle>

      <div className={classes.bodyBorder}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start"
          }}
        >
          <img
            src={SearchIcon}
            alt=""
            style={{ height: "24px", width: "24px" }}
          />
          <MyTypography variant={"subtitle3"} className={classes.nameHead}>
            ค้นหา Ship-to อื่น
          </MyTypography>
        </div>
        <SoldToForShipToInputSuggestion
          searchField="search"
          dataOptions={dataOptions}
          totalCount={dataOptions.length}
          loadingDataSuggestion={loadingDataSuggestionDemostic}
          objectSuggestion
          getDataSuggestions={getDataSuggestionsDemostic}
          contained
          defaultInputValue={initialValue}
          defaultValue={{
            title: initialValue,
            value: initialValue
          }}
          placeholder={"พิมพ์ค้นหา"}
          error={isInValidForm}
          key={" "}
          handleSelectedSearch={handleSelectedSearch}
          formik={formik}
          id="searchOtherShipTo"
        />
      </div>

      {(!isChangeFlow || (isChangeFlow && currentAction === "add")) && (
        <Button
          id="backButton"
          onClick={onBack}
          style={{
            display: "flex",
            justifyContent: "flex-start",
            cursor: "pointer",
            paddingTop: "14px",
            marginLeft: "-5px"
          }}
        >
          <InlineSVG src={BackIcon} style={{ height: "24px", width: "24px" }} />
          <MyTypography variant="body3">Back to Edit Ship-to</MyTypography>
        </Button>
      )}
      <DialogActions className={classes.buttonWrap}>
        <Button
          id="cancelButton"
          variant={"outlined"}
          color={"secondary"}
          className={classes.buttonAction}
          onClick={onClose}
        >
          <FormattedMessage defaultMessage={"ยกเลิก"} />
        </Button>
        <Button
          id="confirmButton"
          variant={"contained"}
          color={"secondary"}
          className={classes.buttonAction}
          disabled={false}
          onClick={onSubmit}
        >
          <FormattedMessage defaultMessage={"ตกลง"} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
ModalSearchShipTo.displayName = "ModalSearchShipTo";
export default ModalSearchShipTo;
